import { InboxFilter } from '../../models';
import { useGetInboxQuery } from '../../services/inbox.service';

interface UseInboxProps {
  filters: InboxFilter;
  paginated: {
    page: number;
    pageSize: number;
  };
}

const useInbox = ({ filters, paginated }: UseInboxProps) => {
  const {
    data: inboxes,
    isLoading,
    error,
  } = useGetInboxQuery(
    { filters, paginated },
    {
      pollingInterval: 2000,
    }
  );

  return {
    error,
    isLoading,
    inboxes: inboxes?.items || [],
    totalItems: inboxes?.count || 0,
    totalPages: inboxes?.count
      ? Math.ceil(inboxes.count / paginated.pageSize)
      : 0,
    stats: inboxes?.stats,
  };
};

export default useInbox;
